// src/index.ts
var isBrowser = () => {
  return typeof window !== "undefined" && typeof window.document !== "undefined";
};
var isNode = () => {
  return typeof process !== "undefined" && process.env != null;
};
var matchesFakeRegex = (testStr, pattern) => {
  const regexPattern = new RegExp(`^${pattern.replace(/\*/g, ".*")}$`);
  return regexPattern.test(testStr);
};
var shouldDebug = (testStr) => {
  if (isBrowser()) {
    const debugValue = window.localStorage.DEBUG;
    if (debugValue === "*") {
      return true;
    }
    const isdebugFromLS = Boolean(
      debugValue && matchesFakeRegex(testStr, debugValue)
    );
    return window.location.search.includes("debug=true") || isdebugFromLS;
  }
  if (isNode()) {
    const debugValue = process.env.DEBUG;
    if (debugValue === "*") {
      return true;
    }
    return Boolean(debugValue && matchesFakeRegex(testStr, debugValue));
  }
  return false;
};
function Debug(filter, action = console.log) {
  return function(...message) {
    if (shouldDebug(filter)) {
      action(...message);
    }
  };
}
var index_default = Debug;

export { Debug, index_default as default };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map